	
var elms = document.getElementsByClassName( 'heroSlide' );
if( elms.length > 0) {
	var heroSplide = new Splide( elms[0], {
		type: 'loop',
		direction: 'ttb',
		height: 'calc( 100vh - var(--wpadmin-height) )',
		rewind: true,
		arrows: false,
		pagination: true,	
		autoplay: 'pause',
		intersection: {
			threshold: .5,
			inView: {
				autoplay: true,
			},
			outView: {
				autoplay: false,
			},
		},
		interval: 5000,
		speed: 1000,
		pauseOnHover: false,
		breakpoints: {
			640: {
				// drag: true,
				direction: 'ltr',
			},
		}
	} ).mount( window.splide.Extensions );
}

var elms_1 = document.getElementsByClassName( 'projectsSlide' );
for ( var i = 0; i < elms_1.length; i++ ) {
	var projectSplide = new Splide( elms_1[ i ], {
		type: 'fade',
		arrows: false,
		pagination: true,	
		rewind: true,
		autoplay: true,
		// intersection: {
		// 	threshold: .5,
		// 	inView: {
		// 		autoplay: true,
		// 	},
		// 	outView: {
		// 		autoplay: false,
		// 	},
		// },
		// interval: 2000,
		// pauseOnHover: false,
		// pauseOnFocus: false,
		drag: false,
		mediaQuery: 'max',
		interval: 4000,
		// breakpoints: {
		// 	767: {
		// 		autoplay: false,
		// 	}
		// }
	} ).mount( window.splide.Extensions );
}

var elms_1 = document.getElementsByClassName( 'twoColumnsWithSlide__gallery' );
for ( var i = 0; i < elms_1.length; i++ ) {
	var twoColumns_splide = new Splide( elms_1[ i ], {
		type: 'fade',
		arrows: true,
		pagination: false,	
		rewind: true,
	} ).on( 'active', function(SlideComponent) {
		SlideComponent.slide.classList.add('animVisible');
	}).on('inactive', function(SlideComponent) {
		SlideComponent.slide.classList.remove('animVisible');
	})
	.on( 'arrows:updated', function(prev, next, prevIndex, nextIndex) { 
		if ( nextIndex < 1) {
			prev.nextElementSibling.children[0].innerHTML = prevIndex + 2;
		} else {
			prev.nextElementSibling.children[0].innerHTML = nextIndex;
		}
	} )
	// .on('move', function() {		
	// 	projectSplide.Components.Autoplay.pause();
	// }).on('moved', function() {
	// 	setTimeout(() => {
	// 		projectSplide.Components.Autoplay.play();
	// 	}, 1000);
	// })
	.mount();
	elms_1[i].addEventListener("mouseenter", function () {
		// on hover in
		// console.log("Hovered element:", this);
		projectSplide.Components.Autoplay.pause();
	});

	elms_1[i].addEventListener("mouseleave", function () {
		// on hover out
		// console.log("Left element:", this);
		projectSplide.Components.Autoplay.play();
	});
}

var elms_2 = document.getElementsByClassName( 'slide__splide' );
for ( var i = 0; i < elms_2.length; i++ ) {
	var splide = new Splide( elms_2[ i ], {
		type: 'fade',
		arrows: true,
		pagination: false,
		rewind: true,
	} ).on( 'move', function() {
		var end = splide.Components.Controller.getEnd() + 1; 
		var progressSpan = splide.root.querySelector('.splide__progress');
		if ( progressSpan ) {
			progressSpan.innerHTML = `<strong>${splide.index + 1}</strong> / ${end}`;
		}
	} ).on( 'moved', function(newIndex, previousIndex, destIndex) {
		splide.Components.Slides.getAt( newIndex ).slide.classList.add('animVisible');
		splide.Components.Slides.forEach( function( Slide, index ) {
			if ( index !== newIndex ) {
				Slide.slide.classList.remove('animVisible');
			}
		});
	}).on('arrows:updated', function(prev, next, prevIndex, nextIndex){
		if( splide.Components && splide.Components.Slides ) {		
			splide.Components.Slides.getAt( prevIndex ).slide.classList.add('animPrev');
			splide.Components.Slides.getAt( nextIndex ).slide.classList.add('animNext');
			splide.Components.Slides.forEach( function( Slide, index ) {
				if ( index !== prevIndex ) {
					Slide.slide.classList.remove('animPrev');
				}
				if ( index !== nextIndex ) {
					Slide.slide.classList.remove('animNext');
				}
			});
		}
	}).mount();
}

var elms_3 = document.getElementsByClassName( 'timeline__splide' );
for ( var i = 0; i < elms_3.length; i++ ) {
	var splide_3 = new Splide( elms_3[ i ], {
		type: 'fade',
		arrows: false,
		pagination: true,	
		drag: false,
		classes: {
			pagination: 'splide__pagination timeline__pagination',
		},
	} ).on( 'pagination:mounted', function ( data ) {
		var slides = data.list.offsetParent.querySelectorAll('.timeline__item:not(.splide__slide--clone)');
		data.items.forEach( function ( item ) {
			item.button.textContent = String( slides[item.page].getAttribute('data-year') );
		} );
	} ).mount();
}

var elms_4 = document.getElementsByClassName( 'timeline__gallery' );
for ( var i = 0; i < elms_4.length; i++ ) {
	var splide_4 = new Splide( elms_4[ i ], {
		type: 'loop',
		rewind: false,
		arrows: true,
		pagination: false,			
		autoplay: false,
		interval: 3000,
		speed: 1000,
		drag: true,
		perPage: 2,
		perMove: 1,
		gap: '.75rem',
	} ).on( 'arrows:updated', function(prev, next, prevIndex, nextIndex) { 
		if ( nextIndex < 1) {
			prev.nextElementSibling.children[0].innerHTML = prevIndex + 2;
		} else {
			prev.nextElementSibling.children[0].innerHTML = nextIndex;
		}
	} ).mount();
}


var elms_5 = document.getElementsByClassName( 'newsListing__container' );
for ( var i = 0; i < elms_5.length; i++ ) {
	var splide_5 = new Splide( elms_5[ i ], {
		type: 'loop',
		rewind: false,
		arrows: true,
		pagination: true,
		classes: {
			pagination: 'splide__pagination newsListing__pagination',
		},	
		mediaQuery: 'min',	
		breakpoints: {
			767: {
				destroy: true,
				perPage: 3,
				gap: '5rem',
			}
		}	
	} ).on( 'arrows:updated', function(prev, next, prevIndex, nextIndex) { 
		if ( nextIndex < 1) {
			prev.nextElementSibling.children[0].innerHTML = prevIndex + 2;
		} else {
			prev.nextElementSibling.children[0].innerHTML = nextIndex;
		}
	} ).mount();
}